import {Share} from './Share'
import {InstagramFeed} from './InstagramFeed'
import {ContactCard} from './ContactCard'
import {Callback} from './Callback'

export * from './LegalDialogs'

export const Dialogs = Object.assign(() => null, {
  ContactCard,
  Callback, // TODO not used
  InstagramFeed,
  Share,
})
